import React, { useEffect, useRef, useState } from "react";
import bgImage from "./img_pro/feshotel.webp";

const Facts = () => {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);
  const counters = useRef([]);

  // Détecte quand la section entre dans le viewport
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  // Animation des compteurs
  useEffect(() => {
    if (!startCount) return;

    counters.current.forEach((counter) => {
      const target = +counter.getAttribute("data-target");
      const suffix = counter.getAttribute("data-suffix");

      let current = 0;

      const update = () => {
        const increment = Math.ceil(target / 100);

        current += increment;

        if (current < target) {
          if (suffix === "+") {
            counter.innerHTML = `<span class="plus">+</span>${current}`;
          } else {
            counter.innerText = current + suffix;
          }

          requestAnimationFrame(update);
        } else {
          if (suffix === "+") {
            counter.innerHTML = `<span class="plus">+</span>${target}`;
          } else {
            counter.innerText = target + suffix;
          }
        }
      };

      update();
    });
  }, [startCount]);

  // Données des compteurs
  const facts = [
    { label: "Clients Satisfaits", target: 1350},
    { label: "Projets Réalisés", target: 1020},
    { label: "Ans d’Expérience", target: 15, suffix: "+" },
    { label: "Taux de Satisfaction", target: 98, suffix: "%" },
  ];

  return (
    <div
      className="facts-section section7 text-white position-relative"
      ref={sectionRef}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "100px 0",
      }}
    >
      {/* Overlay sombre */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.15)",
        }}
      ></div>

      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row g-4 text-center">
          {facts.map((fact, idx) => (
            <div key={idx} className="col-sm-6 col-lg-3">
              <h1
                className="counter display-3 fw-bold"
                data-target={fact.target}
                data-suffix={fact.suffix}
                ref={(el) => (counters.current[idx] = el)}
              >
                {fact.suffix === "+" ? (
                  <>
                    <span className="plus">+ </span>0
                  </>
                ) : (
                  "0"
                )}
              </h1>

              <span
                className="fact-label fs-5 fw-semibold"
                style={{ letterSpacing: "0.5px" }}
              >
                {fact.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Style du + */}
      <style>
        {`
          .plus {
            
            font-size: 40px;
            font-weight: 800;
            vertical-align: top;
            margin-right: 5px;
          }
        `}
      </style>
    </div>
  );
};

export default Facts;